import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TNews, TNewsResponse } from "../../types/newsCard";
import $api, { API } from "../index";

type TDataNews = {
  page: number;
  isVideo?: boolean;
};

export const NEWS_PAGE_SIZE = 10;

export const newsCards = createAsyncThunk(
  "newsCard",
  async (_, { rejectWithValue }): Promise<TNews[]> => {
    try {
      const { data } = await $api.get(`${API.newsPath}`);

      return data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const newsCard = createAsyncThunk(
  "newCard",

  async (id: any, { rejectWithValue }): Promise<TNews> => {
    try {
      const data = await $api.get(`${API.newsPath}/${id}`);
      return data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getNewsPagination = createAsyncThunk(
  `getNewsPagination`,
  async (
    { page, isVideo }: TDataNews,
    { rejectWithValue, signal }
  ): Promise<TNewsResponse> => {
    try {
      let url = `${API.getNewsPagination}?page=${page}&perPage=${NEWS_PAGE_SIZE}`;
      if (isVideo !== undefined) {
        url += `&isVideo=${isVideo}`;
      }
      const response = await $api.get(url, { signal });
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
